<!-- <div class="container-fluid"> -->
  <offer-onb-field-details [disabled_fields]="disable_action" [form_details]="form_details" [type]="4"
    [verificationObj]="verificationObj" [disable_button]="lockDetailsFlag">
  </offer-onb-field-details>
<!-- </div> -->
